





















































































































































































































































import { UserCapability } from "@/data/models/UserCapability";
import {
  getHyDryEventCategoryDescription,
  HyDryEventCategory,
} from "@/data/models/HyDryEvent";
import { createDefaultHyDryMessagesSettings, HyDryMessagesSettings } from "@/data/models/HyDryMessagesConfig";
import {
  getClientInfo,
} from "@/data/repository/ClientRepository";
import { defineOwnHyDryMessagesSettingsClientAccess } from "@/permissions/ClientPermissions";
import { Component, Ref, Watch } from "vue-property-decorator";
import MultiSelectionDialogComponent from "../common/MultiSelectionDialog.vue";
import PickerDialogComponent from "../common/PickerDialog.vue";
import ConfirmationDialogComponent from "../common/ConfirmationDialog.vue";
import { updateHyDryMessagesSettings } from "@/data/repository/SettingsRepository";
import { compareArraysIgnoreOrder } from "@/utils/Utils";
import { HyDryMessagesSettingsModule } from "@/store/modules/HyDryMessagesSettingsModule";
import { COLOR_BLACK_TEXT, COLOR_BLACK_TEXT_DARK, COLOR_READ_ONLY_TEXT, COLOR_READ_ONLY_TEXT_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";
import SettingsPageMixin from "@/components/settings/SettingsPageMixin";

type MessageFilterType = "filterAll" | "filterNoProject" | "filterMyProject" | "erp"; 

@Component({
  components: {
    picker: PickerDialogComponent,
    "multi-selection-dialog": MultiSelectionDialogComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
  },
})
export default class HyDryEventMessageSettingsComponent extends SettingsPageMixin {
  isInitializing = true;

  hyDryMessagesSettings = createDefaultHyDryMessagesSettings();
  initialHyDryMessagesSettings: HyDryMessagesSettings = createDefaultHyDryMessagesSettings();
  onOffValues = [true, false];

  capabilities = [UserCapability.OFFICE, UserCapability.PROJECT_MANAGEMENT];

  selectableHyDryEventCategories = [
    HyDryEventCategory.ORGANISATION,
    HyDryEventCategory.DRYING_PROGRESS,
    HyDryEventCategory.ALERT,
    HyDryEventCategory.OTHER,
  ];

  fieldNamesOrgaRoles: MessageFilterType[] = ["filterAll", "filterNoProject"];
  fieldNamesProjectRoles: MessageFilterType[] = ["filterMyProject"];
  fieldNamesErp: MessageFilterType[] = ["erp"];

  hasSelectedHyDryEventCategoriesChanged = false;

  @Ref("multiSelectionDialog")
  multiSelectionDialog!: MultiSelectionDialogComponent<HyDryEventCategory>;

  @Watch("hyDryMessagesSettingsCached")
  onHyDryMessagesSettingsCachedChanged() {
    if (this.hyDryMessagesSettingsCached && !this.hyDryMessagesSettingsCached.areDefaultHyDryMessagesSettings) {
      this.initializeParameters(this.hyDryMessagesSettingsCached);  
    }
  }

  /** Read-only body text color, theme-aware for dark mode. */
  get readOnlyTextColor() {
    return themed(COLOR_READ_ONLY_TEXT, COLOR_READ_ONLY_TEXT_DARK);
  }

  /** Editable body text color, theme-aware for dark mode. */
  get normalTextColor() {
    return themed(COLOR_BLACK_TEXT, COLOR_BLACK_TEXT_DARK);
  }

  get hyDryMessagesSettingsCached() {
    return HyDryMessagesSettingsModule.hyDryMessagesSettings;
  }

  get hasChanged() {
    return (
      this.hyDryMessagesSettings.mailboxEnabled !== this.initialHyDryMessagesSettings.mailboxEnabled ||
      this.hyDryMessagesSettings.messagesEnabled !== this.initialHyDryMessagesSettings.messagesEnabled ||
      this.hyDryMessagesSettings.messageFilters.showMessagesToProjectOwners !== this.initialHyDryMessagesSettings.messageFilters.showMessagesToProjectOwners ||
      this.hyDryMessagesSettings.messageFilters.showMessagesToProjectSupervisors !== this.initialHyDryMessagesSettings.messageFilters.showMessagesToProjectSupervisors ||
      !compareArraysIgnoreOrder(
        this.hyDryMessagesSettings.messageFilters.erp, 
        this.initialHyDryMessagesSettings.messageFilters.erp
        ) ||
      !compareArraysIgnoreOrder(
        this.hyDryMessagesSettings.messageFilters.filterMyProject,
        this.initialHyDryMessagesSettings.messageFilters.filterMyProject
      ) ||
      this.hasSelectedHyDryEventCategoriesChanged
    );
  }

  get canEdit() {
    return defineOwnHyDryMessagesSettingsClientAccess();
  }

  get readonly() {
    return !this.isEditMode || !this.canEdit;
  }

  get formatOnOff() {
    return (value: boolean) => {
      return this.$t(`common.${value ? "on" : "off"}`).toString();
    };
  }

  get formatYesNo() {
    return (value: boolean) => {
      return this.$t(`common.${value ? "yes" : "no"}`).toString();
    };
  }

  initializeParameters(
    hyDryMessagesSettings: HyDryMessagesSettings
  ) {
    this.hyDryMessagesSettings = hyDryMessagesSettings;

    // Deep copy
    this.initialHyDryMessagesSettings = JSON.parse(JSON.stringify(hyDryMessagesSettings)) as HyDryMessagesSettings;

    this.isEditMode = false;
    this.hasSelectedHyDryEventCategoriesChanged = false;
  }

  mounted() {
    this.isInitializing = true;

    const hyDryMessagesSettings = HyDryMessagesSettingsModule.hyDryMessagesSettings;
    const hyDryMessagesSettingsDeprecated = getClientInfo()?.hyDryMessageSettings;

    if (hyDryMessagesSettings && !hyDryMessagesSettings.areDefaultHyDryMessagesSettings) {
      this.initializeParameters(hyDryMessagesSettings);
    }
    else if (hyDryMessagesSettingsDeprecated) {
      this.initializeParameters(hyDryMessagesSettingsDeprecated);
    }

    this.setToolbarTitle(this.$t("settings.messageSelection").toString());
    this.isInitializing = false;
  }

  getFieldDescription(
    field: MessageFilterType
  ) {
    if (field == "filterAll") {
      return this.$t(`messageSettings.logCategoriesTotal`);
    } else if (field == "filterNoProject") {
      return this.$t(`messageSettings.logCategories`);
    }

    return this.$t(`messageSettings.${field}`);
  }

  getSelectedHyDryEventCategoriesDescription(
    field: MessageFilterType,
    capability?: UserCapability
  ) {
    const selectedHyDryEventCategories = this.getSelectedHyDryEventCategories(
      field,
      capability
    );

    return selectedHyDryEventCategories
      .map((category) =>
        getHyDryEventCategoryDescription(this, category, true).substring(0, 1)
      )
      .join("");
  }

  async onSelectHyDryEventCategories(
    field: MessageFilterType,
    capability?: UserCapability
  ) {
    const newSelection = await this.selectHyDryEventCategories(
      capability
        ? `${this.getCapabilityDescription(
            capability
          )} - ${this.getFieldDescription(field)}`
        : this.getFieldDescription(field).toString(),

      this.getSelectedHyDryEventCategories(field, capability)
    );

    this.setSelectedHyDryEventCategories(field, capability, newSelection);
  }

  async selectHyDryEventCategories(
    label: string,
    currentlySelectedCategories: HyDryEventCategory[]
  ) {
    return this.multiSelectionDialog.show({
      label: label,
      options: this.selectableHyDryEventCategories,
      current: currentlySelectedCategories,
      formatter: (category: HyDryEventCategory) =>
        getHyDryEventCategoryDescription(this, category),
    });
  }

  getCapabilityDescription(capability: UserCapability) {
    if (capability == UserCapability.OFFICE) {
      return this.$t("users.role.office").toString();
    }

    return this.$t("settings.projectManagement.title").toString();
  }

  getSelectedHyDryEventCategories(
    field: MessageFilterType,
    capability?: UserCapability
  ): HyDryEventCategory[] {
    const filter = this.hyDryMessagesSettings.messageFilters[field];

    if (!filter) {
      return [];
    }

    return (
      (capability ? filter[capability] : (filter as HyDryEventCategory[])) ?? []
    );
  }

  setSelectedHyDryEventCategories(
    field: MessageFilterType,
    capability: UserCapability | undefined,
    categories: HyDryEventCategory[]
  ) {
    const update = {
      ...this.hyDryMessagesSettings,
    };

    if (capability) {
      update.messageFilters[field][capability] = categories;
    } else {
      update.messageFilters[field] = categories;
    }

    this.hyDryMessagesSettings = update;
    this.hasSelectedHyDryEventCategoriesChanged = true;
  }

  onToggleShowMessagesToProjectSupervisors() {
    const update = {
      ...this.hyDryMessagesSettings,
    };

    update.messageFilters.showMessagesToProjectSupervisors = !update
      .messageFilters.showMessagesToProjectSupervisors;

    this.hyDryMessagesSettings = update;
  }

  onToggleShowMessagesToProjectOwners() {
    const update = {
      ...this.hyDryMessagesSettings,
    };

    update.messageFilters.showMessagesToProjectOwners = !update.messageFilters
      .showMessagesToProjectOwners;

    this.hyDryMessagesSettings = update;
  }

  async doSave() {
    await updateHyDryMessagesSettings(this.hyDryMessagesSettings);
    this.initialHyDryMessagesSettings = this.hyDryMessagesSettings;
  }
}
